import { render, staticRenderFns } from "./userStatistics3.vue?vue&type=template&id=5e1ed121&scoped=true&"
import script from "./userStatistics3.vue?vue&type=script&lang=ts&"
export * from "./userStatistics3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1ed121",
  null
  
)

export default component.exports